import * as React from "react";
import { Typography } from "@progress/kendo-react-common";
import { GetRouteStateDisplayName } from "../../../../ViewModel/RouteState";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";

function RouteTitle({ route }: { route: FtlRouteViewModel }) {
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <Typography.h3>
      {route.RouteNumber} (
      {route.IsExpired ? "Expired" : GetRouteStateDisplayName(route.State)}
      {route.CarrierInformationIsModified ? ", Carrier modified" : ""})
    </Typography.h3>
  );
}

export default RouteTitle;
